module.exports = __webpack_public_path__ + "img/whatsapp.1eeb778d.svg";